import api from "./axiosClient.js";

/**
 * Get Employees
 */
export const getEmployees = async () => {

  const res = await api.get("/ledger/employees");

  return res.data;

};

/**
 * Get Ledger Entries
 */
export const getLedger = async ({
  accountType,
  accountId,
  fromDate,
  toDate
}) => {

  const res = await api.get("/ledger", {
    params: {
      accountType,
      accountId,
      fromDate,
      toDate
    }
  });

  return res.data;

};

/**
 * Add Ledger Entry
 */
export const addLedgerEntry = async (payload) => {

  const res = await api.post(
    "/ledger",
    payload
  );

  return res.data;

};

/**
 * Update Ledger Entry
 */
export const updateLedgerEntry = async (
  ledgerId,
  payload
) => {

  const res = await api.put(
    `/ledger/${ledgerId}`,
    payload
  );

  return res.data;

};

/**
 * Delete Ledger Entry
 */
export const deleteLedgerEntry = async (
  ledgerId
) => {

  const res = await api.delete(
    `/ledger/${ledgerId}`
  );

  return res.data;

};